import { PostMethod } from '@dill/dill-shared';
import { Robot, HandPointing, UserCircle } from 'phosphor-react';

const methodConfig: Record<
  PostMethod,
  { label: string; icon: React.ReactNode; className: string }
> = {
  AUTO_POST: {
    label: 'Auto-Posted',
    icon: <Robot size={14} weight="fill" />,
    className: 'bg-purple-50 text-purple-700 ring-purple-600/20',
  },
  ONE_CLICK_REVIEW: {
    label: '1-Click Approved',
    icon: <HandPointing size={14} weight="fill" />,
    className: 'bg-blue-50 text-blue-700 ring-blue-600/20',
  },
  EXCEPTION_REVIEW: {
    label: 'Manual (Exception)',
    icon: <UserCircle size={14} weight="fill" />,
    className: 'bg-orange-50 text-orange-700 ring-orange-600/20',
  },
};

interface PostMethodBadgeProps {
  method: PostMethod;
}

export const PostMethodBadge = ({ method }: PostMethodBadgeProps) => {
  const config = methodConfig[method];
  return (
    <span
      className={
        'inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ring-1 ring-inset ' +
        config.className
      }>
      {config.icon}
      {config.label}
    </span>
  );
};
